<div class="container">
  <h1 class="page-title"
    [helpCenterButton]="viewPermissionCode" [lang]="currentLang"
    [helpCenterDownloadButton]="viewPermissionCode" [position]="'inline'" [lang]="currentLang">
    <span class="icon"><i class="fas fa-clipboard-list"></i></span>{{ 'ContainerManagement.Header' | translate }}</h1>
  <p-card>
    <p-accordion>
      <p-accordionTab
        header="{{ 'Common.Form.Header' | translate }}"
        [selected]="isSearchFormOpen">
        <form [formGroup]="searchForm">
          <div class="p-fluid formgrid grid">
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <div class="mb-1">{{ 'ContainerManagement.Search.Facility' | translate }}</div>
              <laas-facility-dropdown 
                formControlName="facility" 
                [isSingle]="true">
              </laas-facility-dropdown> 
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <div class="mb-1">{{ 'ContainerManagement.Search.ContainerNumber' | translate }}</div>
              <p-chips formControlName="containerNos" (onAdd)="chipsAdd($event, 'containerNos')" separator=","></p-chips>
            </div>
            <div class="col-12 md:col-6 lg:col-4 laas-calendar">
              <laas-calendar
                #AssignDate
                [title]="'ContainerManagement.Search.AssignDate'"
                [enableMaxDateIsToday]="false"
                [showRangeMode]="true"
                [showStartMode]="true"
                (onDateChange)="dateOnChange($event,'AssignDate')">
              </laas-calendar>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'ContainerManagement.Search.Period' | translate }}</label>
              <p-dropdown
                [options]="containerTypeOptions"
                placeholder="{{ 'Common.DropDown.Select' | translate }}"
                formControlName="containerType"
                optionValue="value"></p-dropdown>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'ContainerManagement.Search.DONumber' | translate }}</label>
              <p-chips
                formControlName="doNos"
                (onAdd)="chipsAdd($event, 'doNos')"
                separator=","></p-chips>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'ContainerManagement.Search.BookingNo' | translate }}</label>
              <p-chips
                formControlName="bookingNos"
                (onAdd)="chipsAdd($event, 'bookingNos')"
                separator=",">
              </p-chips>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'ContainerManagement.Search.LockStatus' | translate }}</label>
              <p-dropdown
                [options]="isLockOptions"
                placeholder="{{ 'Common.DropDown.Select' | translate }}"
                formControlName="isLock"
                optionValue="value"></p-dropdown>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'ContainerManagement.Search.LicensePlateNo' | translate }}</label>
              <input pInputText type="text" formControlName="licensePlateNo" />
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label class="setting-label">{{ 'ContainerManagement.Search.PlateNoFlag' | translate}}</label>
              <br/>
              <br/>
              <p-inputSwitch formControlName="plateNoFlag" ></p-inputSwitch>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'ContainerManagement.Search.GenerateCrossBoundryNoType' | translate }}</label>
              <p-dropdown [options]="generateCrossBoundryNoOptions"
                          placeholder="{{ 'Common.DropDown.Select' | translate }}"
                          formControlName="generateCrossBoundryNoType"
                          optionValue="value">
              </p-dropdown>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <div class="mb-1">{{ 'ContainerManagement.Search.CrossBoundryNo' | translate }}</div>
              <p-chips formControlName="crossBoundryNos"
              (onAdd)="chipsAdd($event, 'crossBoundryNos')"separator=",">
              </p-chips>
            </div>
          </div>
          <div class="grid">
            <div class="col">
              <button pButton
                      pRipple
                      label="{{ 'Common.Button.Search' | translate }}"
                      (click)="searchBtnClick()"></button>
              <button pButton
                      pRipple
                      label="{{ 'Common.Button.Reset' | translate }}"
                      class="p-button-secondary ml-2"
                      (click)="resetBtnClick($event)"></button>
              <button pButton
                      pRipple
                      label="{{ 'ContainerManagement.Button.ReviewUnallocated' | translate }}"
                      class="p-button-secondary ml-2"
                      (click)="openOrphanDialog($event)"></button>
              <button pButton
                      pRipple
                      label="{{ 'ContainerManagement.Button.CreateContainer' | translate }}"
                      class="p-button-danger ml-3"
                      (click)="createContainerDialog($event)"></button>
              <button *ngIf="table?.selectedRows?.length > 0"
                      pButton
                      pRipple
                      label="{{ 'ContainerManagement.Button.Export' | translate }}"
                      class="p-button-danger ml-3"
                      (click)="export($event)"></button>
              <button *ngIf="(table?.selectedRows?.length == 1) && table?.selectedRows[0]?.isLock == 0"
                      pButton
                      pRipple
                      label="{{ 'ContainerManagement.Search.EditContainer' | translate }}"
                      class="p-button-danger ml-3"
                      (click)="moveOneContainerClick($event)"></button>
              <button *ngIf="displayEditContainerBtn()"
                      pButton
                      pRipple
                      label="{{ 'ContainerManagement.Search.EditContainer' | translate }}"
                      class="p-button-danger ml-3"
                      (click)="moveContainerClick($event)"></button>
              <button *ngIf="displayExportContainerDataDetailExcelBtn()"
                      pButton
                      pRipple
                      label="{{ 'ContainerManagement.Search.Report' | translate }}"
                      class="p-button-danger ml-3"
                      (click)="exportContainerDataDetailExcelClick($event)"></button>
            </div>
          </div>
        </form>
      </p-accordionTab>
    </p-accordion>
    <div class="mt-2">
      <laas-data-table
        #dataTable
        [dataKey]="'seqNo'"
        [tableKey]="preferenceKey"
        [value]="containerResults"
        [defaultColumns]="columns"
        [loading]="containerLoading"
        [lazy]="true"
        [selectable]="true"
        [expandable]="true"
        [isShowCreateRowFunction]="false"
        (savedData)="checkMultipleAddress($event)"
        [editPermission]="editPermissionCode"
        (rowExpanded)="expandContainer($event)"
        (tableOnPage)="tablePageChange($event)"
        (tableOnSort)="tableSort($event)"
        [rowsPerPageOptions]="[5,10,50]"
        [inputValid]="dataInputValid"
        [rowStyle]="containerRowStyle">

        <ng-template pTemplate="caption">
          <div class="flex flex-wrap column-gap-0 row-gap-2 my-1">
            <laas-permission-button *ngIf="!!table?.selectedRows?.length"
              permissionCode="BtnContianerUnLock"
              label="{{ 'ContainerManagement.Button.Unlock' | translate }}"
              (onClick)="lockStatus(false, $event)"></laas-permission-button>
            <laas-permission-button *ngIf="!!table?.selectedRows?.length"
              permissionCode="BtnContianerLock"
              label="{{ 'ContainerManagement.Button.Lock' | translate }}"
              [class]="'p-button-danger'"
              (onClick)="lockStatus(true, $event)"></laas-permission-button>
            <laas-permission-button *ngIf="(table?.selectedRows?.length > 0) && facilityPermission()"
              permissionCode="BtnContianerUnLock"
              label="{{ 'ContainerManagement.Button.Return' | translate }}"
              (onClick)="returnData()"></laas-permission-button>
            <laas-permission-button id="ContainerPackingComboBtn"
              *ngIf="(table?.selectedRows?.length == 1) && canViewContainerPackingComboBtn()"
              label="{{ 'ContainerManagement.Button.ContainerPackingCombo' | translate }}"
              (onClick)="clickContainerPackingComboBtn()"></laas-permission-button>
            <laas-permission-button *ngIf="(table?.selectedRows?.length == 1) && canViewDownloadContainerSignReceiptBtn()"
              label="{{ 'ContainerManagement.Button.DownloadContainerSignReceipt' | translate }}"
              (onClick)="clickDownloadContainerSignReceiptBtn()"></laas-permission-button>
            <laas-permission-button *ngIf="(table?.selectedRows?.length == 1) && canViewSendContainerBoxDetailExcelBtn()"
              label="{{ 'ContainerManagement.Button.SendContainerBoxDetailExcel' | translate }}"
              (onClick)="clickSendContainerBoxDetailExcelBtn()"></laas-permission-button>
            <laas-permission-button *ngIf="(table?.selectedRows?.length == 1) && canViewDownloadUnBondedDocBtn()"
              label="{{ 'ContainerManagement.Button.DownloadUnBondedDoc' | translate }}"
              (onClick)="clickDownloadUnBondedDocBtn()"></laas-permission-button>
          </div>
        </ng-template>

        <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expand">
          <td *ngFor="let col of columns">
            <div [ngSwitch]="col.field">
              <ng-container *ngSwitchCase="'forwarder'">
                <div class="overflow-text">
                  {{ rowData[col.field] | optionsMapping:forwarderOptions | replaceNullWith:'-' }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'consigneeKey'">
                <div class="overflow-text">
                  {{ rowData[col.field] | optionsMapping:customerOptions | replaceNullWith:'-' }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'grossWeight'">
                <div class="overflow-text">
                  {{ rowData[col.field] | number:'1.0':'en-US' | replaceNullWith:'-' }}
                  / {{ rowData['limitKg'] | number:'1.0':'en-US' | replaceNullWith:'-' }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'totalPrice'">
                <div class="overflow-text">
                  {{ rowData[col.field] | number:'1.0':'en-US' | replaceNullWith:'-' }}
                  / {{ rowData['limitUsd'] | number:'1.0':'en-US' | replaceNullWith:'-' }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'cartonCn'">
                <div class="overflow-text">
                  {{ rowData[col.field] | number:'1.0':'en-US' | replaceNullWith:'-' }}
                  / {{ rowData['limitBoxQty'] | number:'1.0':'en-US' | replaceNullWith:'-' }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'cbm'">
                <div class="overflow-text">
                  {{ rowData[col.field] | number:'1.0':'en-US' | replaceNullWith:'-' }}
                  / {{ rowData['limitCbm'] | number:'1.0':'en-US' | replaceNullWith:'-' }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'trPaymentBy'">
                <div class="overflow-text">
                  {{ rowData[col.field] | optionsMapping:forwarderOptions | replaceNullWith:'-' }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'createCarType'">
                <div class="overflow-text car-type-wrap">
                  {{ rowData[col.field] | carTypeMapping:carTypeOptions | replaceNullWith:'-' }}
                </div>
              </ng-container>
              <ng-container *ngSwitchDefault>
                <ng-container [ngSwitch]="col.dataType">
                  <ng-container *ngSwitchCase="'date'">
                    <div class="overflow-text">
                      {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="'boolean'">
                    <div class="overflow-text">
                      {{ rowData[col.field] == 1 ? 'Yes' : 'No' }}
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="'number'">
                    <div class="overflow-text">
                      {{ rowData[col.field] | number:'1.0':'en-US' | replaceNullWith:'-' }}
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchDefault>
                    <div class="overflow-text">
                      {{ rowData[col.field] | replaceNullWith:'-' }}
                    </div>
                  </ng-container>
                </ng-container>
              </ng-container>
            </div>
          </td>
        </ng-template>
        <ng-template pTemplate="bodyInputTemplate" let-rowData let-col="col">
          <ng-container [ngSwitch]="col.field">
            <ng-container *ngSwitchCase="'forwarder'">
              <div class="overflow-text">
                {{ rowData[col.field] | optionsMapping:forwarderOptions | replaceNullWith:'-' }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'consigneeKey'">
              <div class="overflow-text">
                {{ rowData[col.field] | optionsMapping:customerOptions | replaceNullWith:'-' }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'grossWeight'">
              <div class="overflow-text">
                {{ rowData[col.field] | number:'1.0':'en-US' | replaceNullWith:'-' }}
                / {{ rowData['limitKg'] | number:'1.0':'en-US' | replaceNullWith:'-' }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'totalPrice'">
              <div class="overflow-text">
                {{ rowData[col.field] | number:'1.0':'en-US' | replaceNullWith:'-' }}
                / {{ rowData['limitUsd'] | number:'1.0':'en-US' | replaceNullWith:'-' }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'cartonCn'">
              <div class="overflow-text">
                {{ rowData[col.field] | number:'1.0':'en-US' | replaceNullWith:'-' }}
                / {{ rowData['limitBoxQty'] | number:'1.0':'en-US' | replaceNullWith:'-' }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'cbm'">
              <div class="overflow-text">
                {{ rowData[col.field] | number:'1.0':'en-US' | replaceNullWith:'-' }}
                / {{ rowData['limitCbm'] | number:'1.0':'en-US' | replaceNullWith:'-' }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'truckRegisterNo'">
              <button pButton pRipple pTooltip="{{ 'ContainerManagement.Button.GetTruckRegisterSeq' | translate  }}"
                icon="pi pi-arrow-right"(click)="sendTruckRegisterRequest(rowData)">
              </button>
              <input
                type="text"
                pInputText
                [(ngModel)]="rowData[col.field]"
                appendTo="body"
                class="p-fluid"/>
            </ng-container>
            <ng-container *ngSwitchCase="'createCarType'" class="p-fluid">
              <laas-car-type-selector
                [(ngModel)]="rowData.createCarType"
                [facility]="rowData.facility">
              </laas-car-type-selector>
            </ng-container>
            <ng-container *ngSwitchCase="'licensePlateNo'">
              <input
                type="text"
                pInputText
                [(ngModel)]="rowData[col.field]"
                [attr.maxlength]="30"
                appendTo="body"
                class="p-fluid"/>
            </ng-container>

            <ng-container *ngSwitchCase="'trPaymentBy'" class="p-fluid">
              <p-dropdown
                appendTo="body"
                [(ngModel)]="rowData.trPaymentBy"
                placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                [options]="forwarderOptions"
                [showClear]="true"
                [filter]="true">
              </p-dropdown>
            </ng-container>
            <ng-container *ngSwitchDefault>
              <ng-container [ngSwitch]="col.dataType">
                <ng-container *ngSwitchCase="'date'">
                  <div class="overflow-text">
                    {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'boolean'">
                  <div class="overflow-text">
                    {{ rowData[col.field] == 1 ? 'Yes' : 'No' }}
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'number'">
                  <div class="overflow-text">
                    {{ rowData[col.field] | number:'1.0':'en-US' | replaceNullWith:'-' }}
                  </div>
                </ng-container>
                <ng-container *ngSwitchDefault>
                  <div class="overflow-text">
                    {{ rowData[col.field] | replaceNullWith:'-' }}
                  </div>
                </ng-container>
              </ng-container>
            </ng-container>
          </ng-container>
        </ng-template>

        <ng-template pTemplate="bodyOutputTemplate" let-rowData let-col="col">
          <ng-container [ngSwitch]="col.field">

            <ng-container *ngSwitchCase="'forwarder'">
              <div class="overflow-text">
                {{ rowData[col.field] | optionsMapping:forwarderOptions | replaceNullWith:'-' }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'consigneeKey'">
              <div class="overflow-text">
                {{ rowData[col.field] | optionsMapping:customerOptions | replaceNullWith:'-' }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'grossWeight'">
              <div class="overflow-text">
                {{ rowData[col.field] | number:'1.0':'en-US' | replaceNullWith:'-' }}
                / {{ rowData['limitKg'] | number:'1.0':'en-US' | replaceNullWith:'-' }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'totalPrice'">
              <div class="overflow-text">
                {{ rowData[col.field] | number:'1.0':'en-US' | replaceNullWith:'-' }}
                / {{ rowData['limitUsd'] | number:'1.0':'en-US' | replaceNullWith:'-' }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'cartonCn'">
              <div class="overflow-text">
                {{ rowData[col.field] | number:'1.0':'en-US' | replaceNullWith:'-' }}
                / {{ rowData['limitBoxQty'] | number:'1.0':'en-US' | replaceNullWith:'-' }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'cbm'">
              <div class="overflow-text">
                {{ rowData[col.field] | number:'1.0':'en-US' | replaceNullWith:'-' }}
                / {{ rowData['limitCbm'] | number:'1.0':'en-US' | replaceNullWith:'-' }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'trPaymentBy'">
              <div class="overflow-text">
                {{ rowData[col.field] | optionsMapping:forwarderOptions | replaceNullWith:'-' }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'createCarType'">
              <div class="overflow-text car-type-wrap">
                {{ rowData[col.field] | carTypeMapping:carTypeOptions | replaceNullWith:'-' }}
              </div>
            </ng-container>
            <ng-container *ngSwitchDefault>
              <ng-container [ngSwitch]="col.dataType">
                <ng-container *ngSwitchCase="'date'">
                  <div class="overflow-text">
                    {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'boolean'">
                  <div class="overflow-text">
                    {{ rowData[col.field] == 1 ? 'Yes' : 'No' }}
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'number'">
                  <div class="overflow-text">
                    {{ rowData[col.field] | number:'1.0':'en-US' | replaceNullWith:'-' }}
                  </div>
                </ng-container>
                <ng-container *ngSwitchDefault>
                  <div class="overflow-text">
                    {{ rowData[col.field] | replaceNullWith:'-' }}
                  </div>
                </ng-container>
              </ng-container>
            </ng-container>
          </ng-container>
        </ng-template>

        <ng-template pTemplate="rowexpansion" let-rowData let-rowIndex="rowIndex">
          <laas-data-table
            [dataKey]="'doNo'"
            [value]="rowData.dos"
            [defaultColumns]="detailColumns"
            [paginator]="false"
            [style]="{ 'overflow-y': 'auto' }">

            <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expand">
              <td *ngFor="let col of columns">
                <div [ngSwitch]="col.field">
                  <ng-container *ngSwitchCase="'doStatus'">
                    <div class="overflow-text">
                      {{ rowData[col.field] | optionsMapping:doStatusOptions | replaceNullWith:'-' }}
                    </div>
                  </ng-container>

                  <ng-container *ngSwitchDefault>
                    <ng-container [ngSwitch]="col.dataType">
                      <ng-container *ngSwitchCase="'date'">
                        <div class="overflow-text">
                          {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
                        </div>
                      </ng-container>
                      <ng-container *ngSwitchCase="'boolean'">
                        <div class="overflow-text">
                          {{ rowData[col.field] == 1 ? 'Yes' : 'No' }}
                        </div>
                      </ng-container>
                      <ng-container *ngSwitchCase="'number'">
                        <div class="overflow-text">
                          {{ rowData[col.field] | number:'1.0':'en-US' | replaceNullWith:'-' }}
                        </div>
                      </ng-container>
                      <ng-container *ngSwitchDefault>
                        <div class="overflow-text">
                          {{ rowData[col.field] | replaceNullWith:'-' }}
                        </div>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                </div>
              </td>
            </ng-template>

          </laas-data-table>
        </ng-template>
      </laas-data-table>
    </div>
  </p-card>
</div>

<p-dialog header="{{ 'ContainerManagement.Search.EditContainer' | translate }}"
          appendTo="body"
          [modal]="true"
          [draggable]="false"
          [resizable]="false"
          [style]="{width:'70%'}"
          [(visible)]="showMoveContainerDialog">
  <div *ngIf="isLoading" class="fullscreen-loader ">
    <i class="pi pi-spin pi-spinner" style="font-size:2em;color:white"></i>
  </div>
  <div class="p-fluid grid">
    <div class="field col-6">
      <div class="p-fluid grid">
        <div class="field col-6">
          <label>{{ 'ContainerManagement.SubTable.CarType' | translate }}</label>
          <div class="p-1">
            <laas-car-type-selector
                        [(ngModel)]="normalContainer.source.createCarType"
                        [facility]="normalContainer.source.facility"></laas-car-type-selector>
          </div>
        </div>
        <div class="field col-6">
          <label>{{ 'ContainerManagement.SubTable.PlateNo' | translate }}</label>
          <div class="p-1">
            <input pInputText
                   [attr.maxlength]="30"
                   [(ngModel)]="normalContainer.source.plateNo"/>
          </div>
        </div>
      </div>
    </div>
    <div class="field col-6">
      <div class="p-fluid grid">
        <div class="field col-6">
          <label>{{ 'ContainerManagement.SubTable.CarType' | translate }}</label>
          <div class="p-1">
            <laas-car-type-selector
                        [(ngModel)]="normalContainer.target.createCarType"
                        [facility]="normalContainer.target.facility"></laas-car-type-selector>
          </div>
        </div>
        <div class="field col-6">
          <label>{{ 'ContainerManagement.SubTable.PlateNo' | translate }}</label>
          <div class="p-1">
            <input pInputText
                   [attr.maxlength]="30"
                   [(ngModel)]="normalContainer.target.plateNo"/>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div>
    <p-pickList #pl
                [sourceStyle]="{height:'65%'}"
                [targetStyle]="{height:'65%'}"
                [sourceHeader]="getPickListHeader(sourceContainer)"
                [targetHeader]="getPickListHeader(targetContainer)"
                [showSourceControls]="false"
                [showTargetControls]="false"
                [source]="sourceContainer.dos"
                [target]="targetContainer.dos"
                [dragdrop]="true"
                filterBy="carTrip,bookingNo,doNo"
                [responsive]="true"
                [style]="{height:'60vh'}"
                (onMoveToTarget)="moveItem($event)"
                (onMoveToSource)="moveItem($event)"
                (onMoveAllToTarget)="moveItem($event)"
                (onMoveAllToSource)="moveItem($event)">
      <ng-template let-doObj
                   pTemplate="item">
        <div>
          <div style="font-size:14px;margin:15px 5px 0 0 ">{{ doObj.carTrip }} - {{ doObj.bookingNo }}
            - {{ doObj.doNo }} ({{ 'EditContainer.CartonCount' | translate }}:{{
              doObj.cartonCnt |
                number:'1.0':'en-US'
            }} {{ 'EditContainer.NetWeight' | translate }}
            :{{ doObj.totalGrossWeight }} {{ 'EditContainer.Volume' | translate }}
            :{{ doObj.cbm | number:'1.0':'en-US' }}
            {{ 'EditContainer.Value' | translate }}:{{ doObj.totalPrice | number:'1.0':'en-US' }})
          </div>
        </div>
      </ng-template>
    </p-pickList>
  </div>
  <div class="grid mt-5">
    <div class="col">
      <button pButton
              pRipple
              label="{{ 'ContainerManagement.Transfer' | translate }} "
              [loading]="isLoading"
              [disabled]="isLoading"
              (click)="confirmMoveClick($event)"></button>
    </div>
  </div>
</p-dialog>

<p-dialog header="{{ 'ContainerManagement.Search.EditContainer' | translate }}"
          appendTo="body"
          [modal]="true"
          [draggable]="false"
          [resizable]="false"
          [style]="{width:'70%'}"
          [(visible)]="showOneMoveContainerDialog">
  <div *ngIf="isLoading" class="fullscreen-loader">
    <i class="pi pi-spin pi-spinner" style="font-size:2em;color:white"></i>
  </div>
    <div class="p-fluid grid">
      <div class="field col-6">
        <div class="p-fluid grid">
          <div class="field col-6">
          <label>{{ 'ContainerManagement.SubTable.CarType' | translate }}</label>
            <div class="p-1">
            <laas-car-type-selector
                        [(ngModel)]="orphanContainer.source.createCarType"
                        [facility]="orphanContainer.source.facility"></laas-car-type-selector>
          </div>
        </div>
          <div class="field col-6">
          <label>{{ 'ContainerManagement.SubTable.PlateNo' | translate }}</label>
            <div class="p-1">
            <input pInputText
                   [attr.maxlength]="30"
                   [(ngModel)]="orphanContainer.source.plateNo"/>
          </div>
        </div>
      </div>
    </div>
      <div class="field col-6">
    </div>
  </div>
  <div>
    <p-pickList #pl
                [sourceStyle]="{height:'65%'}"
                [targetStyle]="{height:'65%'}"
                [sourceHeader]="getPickListHeader(sourceContainer)"
                [showSourceControls]="false"
                [showTargetControls]="false"
                [source]="sourceContainer.dos"
                [target]="targetOneContainer.dos"
                filterBy="carTrip,bookingNo,doNo"
                [dragdrop]="true"
                [responsive]="true"
                [style]="{height:'60vh'}"
                (onMoveToTarget)="moveItemOnOne($event)"
                (onMoveToSource)="moveItemOnOne($event)"
                (onMoveAllToTarget)="moveItemOnOne($event)"
                (onMoveAllToSource)="moveItemOnOne($event)">
      <ng-template let-doObj
                   pTemplate="item">
        <div>
          <div style="font-size:14px;margin:15px 5px 0 0 ">{{ doObj.carTrip }} - {{ doObj.bookingNo }}
            - {{ doObj.doNo }} ({{ 'EditContainer.CartonCount' | translate }}:{{
              doObj.cartonCnt |
                number:'1.0':'en-US'
            }} {{ 'EditContainer.NetWeight' | translate }}
            :{{ doObj.totalGrossWeight }} {{ 'EditContainer.Volume' | translate }}
            :{{ doObj.cbm | number:'1.0':'en-US' }}
            {{ 'EditContainer.Value' | translate }}:{{ doObj.totalPrice | number:'1.0':'en-US' }})
          </div>
        </div>
      </ng-template>
    </p-pickList>
  </div>
  <div class="grid mt-1">
      <div class="col">
      <button pButton
              pRipple
              label="{{ 'ContainerManagement.Transfer' | translate }}"
              [loading]="isLoading"
              [disabled]="isLoading"
              (click)="confirmOneMoveClick($event)"></button>
    </div>
  </div>
</p-dialog>
<p-dialog header="{{ 'UnallocatedContainer.Header' | translate }}"
          appendTo="body"
          [modal]="true"
          [draggable]="false"
          [resizable]="false"
          [style]="{width:'70%'}"
          [(visible)]="showOrphanDialog">
  <laas-orphan-container></laas-orphan-container>
</p-dialog>

<p-dialog header="{{ 'ContainerManagement.Button.CreateContainer' | translate }}" appendTo="body" [modal]="true" [draggable]="false" [resizable]="false" [style]="{width:'60%'}" [(visible)]="showCreateContainerDialog">
  <laas-create-container *ngIf="showCreateContainerDialog"></laas-create-container>
</p-dialog>

<help-dock
  [permissionCode]="viewPermissionCode"
  [lang]="currentLang">
</help-dock>
